
//used when i need to pass in a user, but its not required
export async function fetchWithOrWithoutAuth(url, options = {}) {
  let token = localStorage.getItem("jwt");

  if (!options.headers) options.headers = {};
  options.headers["Authorization"] = `Bearer ${token}`;

  let response = await fetch(url, options);

  return response;
}

export async function safeJsonFromResponse(response) {
    if (!response) {
        console.log("HTTP response null, likely not authed");
        return null; //HTTP response null, likely not authed
    }
    if (!response || !response.ok) {
        throw new Error(`HTTP ${response.status} ${response.statusText}`);
    }

    const text = await response.text();

    // If response body is empty, return null
    if (!text) return null;

    try {
        return JSON.parse(text);
    } catch (err) {
        console.error('[safeJsonFromResponse] Failed to parse JSON:', err);
        throw new Error('Invalid JSON response');
    }
}


export async function fetchWithAuth(url, options = {}) {
  let token = localStorage.getItem("jwt");
  const refreshTokenVal = localStorage.getItem("refreshtoken");

  // If neither token exists, return early to avoid unnecessary API requests
  if (!token && !refreshTokenVal) {
    console.warn("No authentication tokens available. Skipping API request.");
    return null;
  }


  if (!options.headers) options.headers = {};
    options.headers["Authorization"] = `Bearer ${token}`;

  let response = await fetch(url, options);

  if (response.status === 401) { // Token expired or invalid
    console.log("Token expired, attempting refresh...");
    const refreshSuccess = await refreshToken();

    if (refreshSuccess) {
      token = localStorage.getItem("jwt"); // Get new token
      options.headers["Authorization"] = `Bearer ${token}`;
      response = await fetch(url, options); // Retry original request
    }
  }

  return response;
}

export async function refreshToken() {
  const refreshToken = localStorage.getItem("refreshtoken");
  console.log("!refreshtoken", !refreshToken)
  if (!refreshToken) return false;

  const response = await fetch("/auth/refresh", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ refreshToken }),
  });

  if (response.ok) {
    const data = await response.json();
    localStorage.setItem("jwt", data.accessToken);
    localStorage.setItem("refreshtoken", data.refreshToken);
    return true;
  }

  return false;
}

export async function startTokenRefreshTimer() {
  setInterval(async () => {
    await refreshToken();
  }, 14 * 60 * 1000); // Refresh JWT 1 minute before expiry (15 mins)
}
